import { z } from "zod"
import { SalesDiscountTypeSchema } from "./SalesCommons"

export const SalesDiscountModelSchema = z.object({
	type: SalesDiscountTypeSchema,
})
export type SalesDiscountModel = z.infer<typeof SalesDiscountModelSchema>

export const SalesDiscountCodeModelSchema = z.object({
	/**
	 * Unique identifier for the discount code.
	 */
	id: z.string().min(1),

	/**
	 * The code that customers enter to apply the discount.
	 */
	name: z.string().min(1),

	active: z.boolean(),

	discounts: z.array(SalesDiscountModelSchema),
})

export type SalesDiscountCodeModel = z.infer<typeof SalesDiscountCodeModelSchema>
